// This key is not secret so we are fine with checking it into the repo
export const AMPLITUDE_PUBLIC_KEY = "0c81fab94b6f7b6750a4e754570d471b";
